import { makeAutoObservable } from 'mobx'
import { type IAvatarInfo } from 'shared/ui'
import { type IResponseTwilioContact } from 'entities/Call/api/types'

const AVATAR_COLORS = ['#6372A5', '#1D95F2', '#10D0AD', '#E13466', '#FFC422', '#FF9423', '#A233E1']

export class TwilioContact {
  id: number
  first_name: string
  last_name: string
  full_name: string
  number: string
  national_number: string
  formatted_number: string
  photo_url: string
  email: string | null

  constructor(payload: IResponseTwilioContact) {
    this.id = payload.id
    this.first_name = payload.first_name ?? ''
    this.last_name = payload.last_name ?? ''
    this.full_name = (payload.full_name ?? '').trim()
    this.number = payload.number ?? ''
    this.national_number = payload.national_number ?? ''
    this.formatted_number = payload.formatted_number ?? ''
    this.photo_url = payload.photo_url ?? ''
    this.email = payload.email

    makeAutoObservable(this)
  }

  get color(): string {
    return AVATAR_COLORS[this.id % AVATAR_COLORS.length]
  }

  get name(): string {
    if (this.full_name) return this.full_name
    if (this.email) return this.email
    if (this.number) return this.number
    return ''
  }

  get isUnknownContact(): boolean {
    return !this.first_name.trim() && !this.last_name.trim()
  }

  get avatarInfo(): IAvatarInfo {
    return {
      isPhoneAbbr: !this.first_name && !this.last_name,
      firstName: this.first_name,
      lastName: this.last_name,
      image: this.photo_url,
      color: this.color,
      number: this.number,
    }
  }
}
